// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".WL7nL9WUGEPK2zcTZJD0 {\n  background-color: var(--travel-body-background) !important;\n  min-width: 160px;\n  padding: 12px !important;\n}\n", "",{"version":3,"sources":["webpack://./libs/shared/ui/inputs/select/select.module.css"],"names":[],"mappings":"AAAA;EACE,0DAA0D;EAC1D,gBAAgB;EAChB,wBAAwB;AAC1B","sourcesContent":[".select {\n  background-color: var(--travel-body-background) !important;\n  min-width: 160px;\n  padding: 12px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"select": "WL7nL9WUGEPK2zcTZJD0"
};
export default ___CSS_LOADER_EXPORT___;
